<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg12>
          <p class="table_card__head--title">
            Importador de empleados
          </p>
          <v-breadcrumbs class="breadcums">
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Importador
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <section v-if="charge" class="trainers__create_container">
        <v-layout row wrap>
          <v-flex xs8>
            <div :style="excelTitle.length<=0?'':''">
              <!-- Fotos de la oferta -->
              <span class="table_card__info--label">Adjuntar información (Formato Excel)</span>
              <div class="trainers__form--photo_container" style="width:max-content">
                <label
                  for="excel_input"
                  class="faccess_button buttom_shadow px-5">Examinar</label>
                <input
                  id="excel_input"
                  type="file"
                  @change="excelUpload()"
                  name="logo"
                  multiple>
                  <p class="accessIndex__text--small" style="margin-left:10%" v-if="excelTitle.length<=0" >Debe adjuntar un archivo con formato Excel</p>
              </div>
              </div>
            <v-flex>
                <div v-if="excelTitle.length!=0">
                  <p class="data_card__info--label">Nombre del archivo </p>
                  <p style="font-size: 10px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
                </div>
            </v-flex>
          </v-flex>
          <v-flex xs4 v-if="excelTitle.length!=0" >
            <section class="data_card data_card__instance">
            </section>
            <button style="float: right;"
              class="faccess_button"
              @click="uploadInfo()">
              Cargar Datos
            </button>
          </v-flex>
          <v-flex  xs12>
            <div v-if="tableData.length>0" style="margin-top: 30px;">
              <v-data-table
                :headers="headers"
                :items="tableData"
                class="elevation-1"
                hide-actions>
                <template slot="items" slot-scope="props">
                  <tr class="importers__user_row">
                    <td v-for="data in Object.entries(props.item)" class="importers__user_data">
                      <input v-model=" data[1][0] " :placeholder="data[0]" class="importers__input_data">
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      charge: true,
      tableData: [],
      access: [],
      excelTitle:"",
      isHidden:false,
      renderComponents:true,
      headers: [
        {
          text: 'Rut',
          align: 'left',
          sortable: false,
          value: 'Rut'
        },
        {
          text: 'Tipo de documento',
          align: 'left',
          sortable: false,
          value: 'Tipo de documento'
        },
        {
          text: 'Email',
          align: 'left',
          value: 'Email',
          sortable: false,
        },
        {
          text: 'Nombre',
          align: 'left',
          sortable: false,
          value: 'Nombre'
        },
        {
          text: 'Apellido',
          align: 'left',
          sortable: false,
          value: 'Apellido'
        },
        {
          text: 'Celular',
          align: 'left',
          sortable: false,
          value: 'Celular'
        },
        {
          text: 'Genero',
          align: 'left',
          sortable: false,
          value: 'Genero'
        },
        {
          text: 'Fecha de nacimineto',
          align: 'left',
          sortable: false,
          value: 'Fecha de nacimineto'
        },
        {  
          text: 'Nacionalidad',
          align: 'left',
          sortable: false,
          value: 'Nacionalidad'
        },
        {  
          text: 'Plan de usuario',
          align: 'left',
          sortable: false,
          value: 'Plan de usuario'
        },
      ],
    }
  },
  mounted(){
    
  },
  watch:{

  },
  computed: {
  /*    parmsCompanyId: function() {
        return this.$route.params.id;
    }, */
  },
  methods:{
    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if (regex.test(fileUpload.value.toLowerCase())) {
        var vm=this;
        if (typeof (FileReader) != "undefined") {
            var reader = new FileReader();
            vm.excelTitle=fileUpload.files[0].name;
            //For Browsers other than IE.
            if (reader.readAsBinaryString) {
                reader.onload = function (e) {
                  vm.usersJson={};
                  vm.ProcessExcel(e.target.result);
                };
                reader.readAsBinaryString(fileUpload.files[0]);
            } else {
              //For IE Browser.
              reader.onload = function (e) {
                  var data = "";
                  var bytes = new Uint8Array(e.target.result);
                  for (var i = 0; i < bytes.byteLength; i++) {
                    data += String.fromCharCode(bytes[i]);
                  }
                  vm.ProcessExcel(data);
              };
              reader.readAsArrayBuffer(fileUpload.files[0]);
            }
        } else {
          alert("This browser does not support HTML5.");
        }
      } else {
        alert("Por favor subir un archivo de códigos válido (Formato Excel).");
      }
    },
    ProcessExcel(data){
      //Read the Excel File data.
      var workbook = XLSX.read(data, {
        type: 'binary'
      });

      //Fetch the name of First Sheet.
      var firstSheet = workbook.SheetNames[0];

      //Read all rows from First Sheet into an JSON array.
      var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
      var excelRowsJson = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], {raw: true});
      this.XLSX = excelRowsJson;
      console.log('Excel Rows!!!', excelRows);
      console.log('Excel Rows JSON!!!', excelRowsJson);
      var header = Object.keys(excelRowsJson[0]);

      //Add the data rows from Excel file.
      for (var i = 0; i < excelRows.length; i++) {
        //Add the data row.
        var array = {};

        for (var a = 0; a < header.length; a++) {
          array[header[a]] = [excelRowsJson[i][header[a]]];
        }
        this.tableData.push(array);        
        //Add the data cells.
      }
      console.log('Data en la tabla!!! ',this.tableData);
    },
    uploadInfo(){
      let finalJson={new: this.tableData, company_id: this.getCompany().id}
      try
      { 
        this.$http.post('employees/upload_employee_or_create',{
          data: this.encrypt(finalJson).toString(),
        },
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }

        }).then(function(response){
          this.charge = false;
          this.$router.push({name: 'import_employees'});
          this.tableData = []
          this.excelTitle = ""
          setTimeout(()=> { this.charge = true; },1000)
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);
          
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.errors[0].title.includes("invalid input syntax for type date:")){
            this.updateAlertMessage("Las fechas ingresadas en el archivo no tienen el formato correcto");
            this.updateIsInAlert(true);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      catch (e)
      {
        alert(e.message)
      }
    }
  }
}

</script>

<style lang="css">
p{
  margin-bottom: 0;
}

.text_title{
  font-weight: bold;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/import_users/ImportEmployee.vue